export const THEMES = ['light', 'dark'] as const

export type Theme = (typeof THEMES)[number]

export const DEFAULT_THEME: Theme = 'dark'

export const isTheme = (value: unknown): value is Theme => THEMES.includes(value as Theme)
